import React from 'react';
import PropTypes from 'prop-types';
import { createVariants } from './_variants';

const containerClasses = createVariants({
  base: 'w-full',
  variants: { primary: '', outline: '', ghost: '' },
  sizes: { sm: '', md: '', lg: '' },
  defaultVariant: 'outline',
  defaultSize: 'md',
});

const tabButtonClasses = createVariants({
  base: 'px-1 pb-2 -mb-px inline-flex items-center font-medium border-b-2 transition-theme duration-theme',
  variants: {
    primary: 'text-succession-text-primary data-[inactive=true]:text-succession-text-secondary data-[inactive=true]:hover:text-succession-text-primary',
    outline: 'text-succession-text-primary data-[inactive=true]:text-succession-text-secondary data-[inactive=true]:hover:text-succession-text-primary',
    ghost: 'text-succession-text-primary data-[inactive=true]:text-succession-text-secondary data-[inactive=true]:hover:text-succession-text-primary',
  },
  sizes: { sm: 'text-[13px]', md: 'text-[15px]', lg: 'text-base' },
  defaultVariant: 'outline',
  defaultSize: 'md',
});

const Tabs = ({ tabs, value, onChange, showDescription = true, className, variant = 'outline', size = 'md' }) => {
  const container = containerClasses({ variant, size, className, disabled: false });
  const active = (tabs || []).find((t) => t.id === value);

  return (
    <div className={container}>
      <div className="mt-3 flex items-center gap-6 border-b border-succession-border" role="tablist">
        {(tabs || []).map((tab) => {
          const isActive = tab.id === value;
          const classes = tabButtonClasses({ variant, size, className: isActive ? 'border-succession-primary' : 'border-transparent', disabled: false });
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              data-inactive={isActive ? undefined : true}
              className={classes}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {showDescription && active && active.description ? (
        <div className="mt-2 mb-3 py-2 pl-2 border-b border-succession-border">
          <p className="text-succession-text-secondary text-sm m-0">{active.description}</p>
        </div>
      ) : null}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  showDescription: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'outline', 'ghost']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default Tabs;


